import { useTranslation } from "react-i18next";
import { useSiteConfig } from "../config/SiteConfigContext";

/**
 * Scelta consenso marketing diretto (finalità D) — SOLO nel form di registrazione.
 *
 * Due radio dello stesso gruppo, di pari peso visivo (nessun dark pattern), NON
 * preselezionati: `value` iniziale `null` = nessuna scelta. La scelta è facoltativa:
 * l'utente può registrarsi anche senza selezionare (il chiamante invia `null`).
 * fieldset/legend per l'accessibilità dello screen reader.
 */
export function MarketingConsentFields({
  value,
  onChange,
}: {
  value: boolean | null;
  onChange: (v: boolean) => void;
}) {
  const { t } = useTranslation();
  const cfg = useSiteConfig();

  const optionStyle: React.CSSProperties = {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    cursor: "pointer",
    fontSize: 13,
    color: cfg.color_dark,
  };
  const radioStyle: React.CSSProperties = { accentColor: cfg.color_dark, width: 16, height: 16, cursor: "pointer" };

  return (
    <fieldset style={{ border: "none", margin: 0, padding: 0, minInlineSize: "auto" }}>
      <legend style={{ fontSize: 12, color: cfg.color_dark, fontWeight: 500, lineHeight: 1.5, padding: 0, marginBottom: 10 }}>
        {t("auth.marketingIntro")}
      </legend>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 24 }}>
        <label style={optionStyle}>
          <input
            type="radio"
            name="marketing_consent"
            checked={value === true}
            onChange={() => onChange(true)}
            style={radioStyle}
          />
          {t("auth.marketingAgree")}
        </label>
        <label style={optionStyle}>
          <input
            type="radio"
            name="marketing_consent"
            checked={value === false}
            onChange={() => onChange(false)}
            style={radioStyle}
          />
          {t("auth.marketingDisagree")}
        </label>
      </div>
    </fieldset>
  );
}
